import type { AccountTotalRow } from '../types';
import { fmtMoney } from '../lib/format';

const KIND_LABEL: Record<AccountTotalRow['kind'], string> = {
  credit_card: 'Credit card',
  checking:    'Checking',
  stripe:      'Stripe',
  square:      'Square',
  manual:      'Manual',
};

export function AccountBreakdown({ rows }: { rows: AccountTotalRow[] }) {
  if (rows.length === 0) {
    return (
      <Section title="Per-account">
        <Empty>No accounts connected yet. Click <strong>Connect a card</strong> up top to add your first Amex or Chase.</Empty>
      </Section>
    );
  }

  return (
    <Section title="Per-account">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-slate-500 text-xs uppercase tracking-wide">
            <th className="py-2">Account</th>
            <th className="py-2">Type</th>
            <th className="py-2 text-right">Transactions</th>
            <th className="py-2 text-right">Net</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="border-t border-slate-100">
              <td className="py-2.5 font-medium">{r.display_name}</td>
              <td className="py-2.5 text-slate-600">{KIND_LABEL[r.kind]}</td>
              <td className="py-2.5 text-right tnum">{r.tx_count}</td>
              <td className={`py-2.5 text-right tnum font-semibold ${r.total_cents < 0 ? 'text-rose-700' : 'text-emerald-700'}`}>
                {fmtMoney(r.total_cents, { sign: true })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Section>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5">
      <h2 className="text-sm font-semibold text-slate-700 mb-3">{title}</h2>
      {children}
    </div>
  );
}

function Empty({ children }: { children: React.ReactNode }) {
  return <div className="text-sm text-slate-500 py-4">{children}</div>;
}
